

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */

import $ from 'jquery';

import { PdfLocationMillis, PdfLocationPoints } from './geometry2d';

export function DocReaderPanes(handler, eventEmitter) {
    const self = this;
    self.active = null;
    self.pane = {
        sign: {
            btn: $('#firme-doc'),
            fn: handler.signsOpen,
            active: false,
            container: '#firmecontainer',
            hasWorkbox: true,
            hasPadding: true,
            size: null,
            placement: null,
            isHorizontal: null,
        },
        wizard: {
            btn: $('#uniwizard'),
            fn: handler.wizardOpen,
            active: false,
            container: '#wizardcontainer',
            hasWorkbox: false,
            hasPadding: false,
            size: null,
            placement: null,
            isHorizontal: null,
        },
    };

    self.paneOpenClose = function(pane, { veryFast } = {}) {
        const active = self.active;
        if(typeof (pane) == 'string') {
            if(pane == 'active') {
                if(!active)
                    return Promise.resolve();
                pane = active;
            } else {
                pane = self.pane[pane];
            }
        }

        const switched = handler.makePaneVisible('dviewerbox');
        if(active === pane) {
            if(pane.hasWorkbox && switched) {
                eventEmitter.emit('ui:resized');
                return Promise.resolve();
            }
        }
        let workboxHidden = false;
        if($('#dviewerworkbox').is(':visible')) {
            $('#dviewerworkbox').hide();
            $('#doccontainer').show();
            workboxHidden = true;
        }
        const easing = veryFast ? 1 : 'slow';
        if(active === pane) {
            if(pane.hasWorkbox && workboxHidden) {
                return Promise.resolve();
            }
            pane.btn.removeClass('active');
            pane.active = false;
            self.active = null;
            eventEmitter.emit('ui:recalculate', { noemit: true });
            return new Promise(function(resolve) {
                $(pane.container).animate(pane.isHorizontal ? { height: 'hide' } : { width: 'hide' }, easing, function() {
                    setTimeout(function() {
                        eventEmitter.emit('ui:recalculate', { noemit: false });
                        eventEmitter.emit('ui:pane-openclose');
                        resolve();
                    }, 100);
                });
            });
        }
        if(active) {
            active.btn.removeClass('active');
            $(active.container).hide();
            active.active = false;
            self.active = null;
            eventEmitter.emit('ui:recalculate', { noemit: true });
        }
        pane.btn.addClass('active');
        pane.active = true;
        self.active = pane;
        return new Promise(function(resolve) {
            const container = $(pane.container);
            container.animate(pane.isHorizontal ? { height: 'show' } : { width: 'show' }, easing, function() {
                if(container.is(':empty')) {
                    pane.fn.call(handler, container);
                }
                setTimeout(function() {
                    eventEmitter.emit('ui:recalculate', { noemit: false });
                    eventEmitter.emit('ui:pane-openclose');
                    resolve();
                }, 100);
            });
        });
    };
}


export function SizeHandler(__docMeta, docreaderPanes, eventEmitter) {
    const self = this;
    const regex = /^(\d+)(px|%)?$/;
    let freezeUi = false;

    eventEmitter.on('ui:resizing', function() {
        //not initialized, should be called from updateUi first
        if(!self.wndsize || freezeUi)
            return;
        self.recalcSizeUi();
    });
    eventEmitter.on('ui:recalculate', function({ noemit } = {}) {
        self.recalcSizeUi(true, noemit);
    });
    function _docMeta() {
        return (typeof (__docMeta) == 'function') ? __docMeta() : __docMeta;
    }

    self.wndsize = null;
    self.mainsize = null;
    self.uisize = null;
    self.viewersize = null;
    self.menusize = null;
    self.docsize = null;
    self.iframesize = null;
    self.panesizepad = null;
    self.wizardsize = null;

    self.showTitle = true;
    self.showMenu = true;

    function SizeConstraint(c) {
        let num;
        let cnt = null;
        if(typeof (c) == 'number') {
            num = c;
        } else {
            const match = c.match(regex);
            if(match) {
                num = Number(match[1]);
                cnt = match[2];
            } else {
                num = 0;
            }
        }

        this.num = num;
        this.cnt = cnt || 'px';
        this.css = String(Math.round(this.num)) + this.cnt;
        this.toAbsolute = function(owner) {
            if(this.cnt == 'px')
                return this;

            if(owner.cnt == 'px')
                return new SizeConstraint((owner.num * this.num) / 100);

            return new SizeConstraint(0);
        };
    }
    function SizeConstraints(w, h) {
        if(typeof (w) == 'object') {
            if(typeof (h) == 'object') {
                this.w = w;
                this.h = h;
            } else {
                h = w.height;
                w = w.width;
            }
        }

        this.w = this.w || new SizeConstraint(w);
        this.h = this.h || new SizeConstraint(h);
        this.toAbsolute = function(owner) {
            return new SizeConstraints(this.w.toAbsolute(owner.w), this.h.toAbsolute(owner.h));
        };
        this.css = function() {
            return {
                width: this.w.css,
                height: this.h.css,
            };
        };
        this.str = function() {
            const css = this.css();
            return 'width:' + css.width + 'px;height:' + css.height + 'px;';
        };
    }

    const willDump = false;
    function calcSizeUi(force) {
        const wndsize = new SizeConstraints($(window).width(), $(window).height());
        if(!force && self.wndsize && (self.wndsize.str() == wndsize.str()))
            return false;

        const docMeta = _docMeta();
        let resizer = docMeta && docMeta.profile && docMeta.profile.resizer;
        if(!resizer) {
            //default
            resizer = {
                'width': '972px',
                'height': '643px',
            };
        }

        let mainsize = new SizeConstraints(resizer.width, resizer.height);
        mainsize = mainsize.toAbsolute(wndsize);

        const titleheight = (self.showTitle ? 62 : 0) + 27; //62 + 4x2 + 15 + (4)
        const uisize = { w: mainsize.w.num, h: mainsize.h.num - titleheight };
        const menusize = self.showMenu ? { w: 120, h: uisize.h } : { w: 0, h: uisize.h };
        const viewersize = { w: uisize.w - menusize.w, h: uisize.h };
        const iframesize = { w: viewersize.w - 7, h: viewersize.h - 5 };

        const paneborders = 2; // 2 x borders(1)
        const panepadding = 10; //2 x padding(5)
        for(const paneName in docreaderPanes.pane) {
            const pane = docreaderPanes.pane[paneName];
            let paneDim = 140;
            let panePlacement = 'top';
            if((paneName == 'wizard') && (docMeta.wizdata)) {
                if(docMeta.wizdata.wizardPaneSize)
                    paneDim = docMeta.wizdata.wizardPaneSize;
                if(docMeta.wizdata.wizardLocation)
                    panePlacement = docMeta.wizdata.wizardLocation;
            }

            const isHorizontal = (panePlacement == 'top') || (panePlacement == 'bottom');
            pane.isHorizontal = isHorizontal;
            pane.placement = panePlacement;
            let panesize;
            if(isHorizontal) {
                panesize = { w: viewersize.w - paneborders, h: paneDim };
            } else {
                panesize = { w: paneDim, h: viewersize.h - paneborders };
            }
            if(pane.hasPadding) {
                panesize.w -= panepadding;
                panesize.h -= panepadding;
            }
            pane.size = new SizeConstraints(panesize.w, panesize.h);
        }

        let docsize;
        if(docreaderPanes.active) {
            const pane = docreaderPanes.active;
            if(pane.isHorizontal) {
                docsize = {
                    w: viewersize.w,
                    h: viewersize.h - pane.size.h.num - paneborders - (pane.hasPadding ? panepadding : 0),
                };
            } else {
                docsize = {
                    w: viewersize.w - pane.size.w.num - paneborders - (pane.hasPadding ? panepadding : 0),
                    h: viewersize.h,
                };
            }
        } else {
            docsize = viewersize;
        }

        self.wndsize = wndsize;
        self.mainsize = mainsize;
        self.uisize = new SizeConstraints(uisize.w, uisize.h);
        self.viewersize = new SizeConstraints(viewersize.w, viewersize.h);
        self.menusize = new SizeConstraints(menusize.w, menusize.h);
        self.docsize = new SizeConstraints(docsize.w, docsize.h);
        self.iframesize = new SizeConstraints(iframesize.w, iframesize.h);

        if(willDump)
            dump();
        return true;
    }

    function dump() {
        const allobj = {
            'window': self.wndsize,
            '#fwmain': self.mainsize,
            '#dviewerbox': self.viewersize,
            '.dviewercontainer': self.uisize,
            '.dviewermenu': self.menusize,
            '.docbox': self.docsize,
            'iframe.pane': self.iframesize,
        };
        for(const paneName in docreaderPanes.pane) {
            const pane = docreaderPanes.pane[paneName];
            allobj[pane.container] = pane.size;
        }

        let text = '';
        for(const name in allobj) {
            text += name + '\t' + allobj[name].str() + '\n';
        }
        window.console && console.log && console.log(text);
    }

    self.freezeUi = function(freeze) {
        freezeUi = freeze;
    };
    self.recalcFrameUi = function() {
        calcSizeUi();
        $('iframe.pane').css(self.iframesize.css());
    };

    self.recalcSizeUi = function(force, noemit) {
        if(!calcSizeUi(force))
            return false;

        $('#fwmain').css(self.mainsize.css());

        $('.dviewercontainer').css(self.uisize.css());
        $('#dviewerbox').css(self.viewersize.css());

        $('.dce_header').toggleClass('hidden', !self.showTitle);
        $('.dviewermenu').css(self.menusize.css()).toggleClass('hidden', !self.showMenu);

        $('.docbox').css(self.docsize.css());
        $('.dviewer').filter(':not(#dviewerbox)').css(self.docsize.css());
        $('#doccontainer').css(self.docsize.css());
        $('#dviewerworkbox').css(self.docsize.css());

        $('iframe.pane').css(self.iframesize.css());

        for(const paneName in docreaderPanes.pane) {
            const pane = docreaderPanes.pane[paneName];
            $(pane.container).css(pane.size.css());
        }
        if(!noemit)
            eventEmitter.emit('ui:resized');
        return true;
    };
}


export function PdfSelectionRect(page, x, y, w, h, docreader, currentRenderer, eventEmitter) {
    const self = this;
    const location = new PdfLocationPoints({
        x, y, w, h,
    });
    const isRendererSupported = currentRenderer.isExternalPdfRenderer;
    let signhighlight = null;
    let isCurrentlyRendering = false;

    eventEmitter.on('ui:renderer-resized', pageSizeChanged);
    function pageSizeChanged() {
        if(signhighlight) {
            positionHighlight(calculateRectLocation());
        }
    }
    function calculateRectLocation() {
        const pageRect = currentRenderer.getCurrentPageSizeInPixels();
        const locationRect = location.toPixels({ pointsToScrenRatio: pageRect.pointsToScrenRatio });
        return locationRect;
    }
    function createHighLight(locationRect) {
        if(!signhighlight) {
            signhighlight = $('<div class="signhighlight"></div>').appendTo('#pagecnt');
            positionHighlight(locationRect);
        }
    }
    function positionHighlight(locationRect) {
        signhighlight.css({
            left: locationRect.x,
            top: locationRect.y,
            width: locationRect.w,
            height: locationRect.h,
        });
    }
    self.isCurrentlyRendering = function() {
        return isCurrentlyRendering;
    };
    self.createHighlight = function() {
        createHighLight(calculateRectLocation());
    };
    self.ensureVisible = function({ skipPage, highlight } = {}) {
        if(!isRendererSupported)
            return Promise.resolve();
        isCurrentlyRendering = true;
        return Promise.resolve()
            .then(() => {
                if(skipPage)
                    return null;
                return docreader.loadPage(page);
            })
            .then(() => {
                const locationRect = calculateRectLocation();
                if(highlight) {
                    createHighLight(locationRect);
                }
                return docreader.scrollToLocation(locationRect);
            })
            .finally(() => {
                isCurrentlyRendering = false;
            });
    };
    self.destroy = function() {
        eventEmitter.off('ui:renderer-resized', pageSizeChanged);
        if(signhighlight)
            signhighlight.remove();
    };
}


//api compatible with SignatureBox, but only make waitcursor for everything
export function InvisibleSignatureBox(handler, { position }, { needModals } = {}) {
    const self = this;
    self.img = null;
    self.canvas = null;
    self.signatureContainerBox = null;
    self.bitmapurl = '';

    let modal = null;
    let isCurrentlyRendering = false;

    self.destroy = function() {
        if(modal)
            modal.remove();
        return Promise.resolve();
    };

    self.position = function(callback) {
        isCurrentlyRendering = true;
        return Promise.resolve()
            .then(() => handler.loadPage(position.page - 1))
            .then(() => {
                if(needModals) {
                    const body = $(document.body);
                    modal = $(`<div id="waiting-dlg">
<img id="waiting-img" alt="Elaborazione..." title="Elaborazione..." src="images/loading.gif" />
</div>`).appendTo(body);
                }
                callback && callback();
            })
            .finally(() => {
                isCurrentlyRendering = false;
            });
    };

    self.pleaseWait = function(show) {};
    self.setTitle = function(title) {};
    self.isCurrentlyRendering = function() { return isCurrentlyRendering; };
}


//position and signarea are suddenly in millimeters
export function SignatureBox(
    handler,
    eventEmitter,
    { position, signarea, bitmapurl },
    {
        needModals, needTitle, hideui, zoomArea, zoomRatio,
    } = {},
) {
    const self = this;
    self.img = null;
    self.canvas = null;
    self.signatureContainerBox = null;
    self.bitmapurl = bitmapurl;

    let isCurrentlyRendering = false;

    let modal = null;
    let signatureSelectionBox = null;
    let signatureMainBox = null;
    let signatureTitle = null;
    let signatureTitleText = null;
    let signatureContainerBox = null;
    let signatureImage = null;
    let signatureWindow = null;
    let signatureWait = null;

    let wizardHidden = false;
    let pointsToScrenRatio = null;

    function create() {
        const pagecnt = $('#pagecnt');

        pagecnt.append('<div id="signatureSelectionBox"/>');
        signatureSelectionBox = $('#signatureSelectionBox');

        pagecnt.append('<div id="signatureMainBox">'
                + '<div id="signatureTitle"><div id="signatureTitleText"></div></div>'
                + '<div id="signatureContainerBox" tabindex="0">'
                + '<img id="signatureImage" style="touch-action:none;"></img>'
                + '<canvas id="signatureWindow" style="touch-action:none;"></canvas>'
                + '<div id="signatureWait" style="touch-action:none;"></div></div>'
                + '</div>');
        signatureMainBox = $('#signatureMainBox');
        signatureTitle = $('#signatureTitle');
        signatureTitleText = $('#signatureTitleText');
        signatureContainerBox = $('#signatureContainerBox');
        signatureImage = $('#signatureImage');
        signatureWindow = $('#signatureWindow');
        signatureWait = $('#signatureWait');

        self.img = signatureImage[0];
        self.canvas = signatureWindow[0];
        self.signatureContainerBox = signatureContainerBox[0];
    }

    function calcPositionAndShow() {
        const selectionPos = new PdfLocationMillis(position).toPixels({ pointsToScrenRatio });
        let signaturePos = selectionPos;
        if(signarea)
            signaturePos = new PdfLocationMillis(signarea).toPixels({ pointsToScrenRatio });

        signatureSelectionBox.css({
            left: selectionPos.x, top: selectionPos.y, width: selectionPos.w, height: selectionPos.h,
        });
        const borderSize = parseInt(signatureMainBox.css('border-left-width'), 10);

        let titleHeight = 0;
        if(needTitle) {
            const titleBorder = parseInt(signatureTitleText.css('border-left-width'), 10) * 2;
            const titlePaddingWidth = parseInt(signatureTitle.css('padding-left'), 10) * 2;
            const titlePaddingHeight = parseInt(signatureTitle.css('padding-top'), 10) * 2;
            titleHeight = signatureTitle.height() + titlePaddingHeight;
            signatureTitle.css({ width: signaturePos.w - titlePaddingWidth });
            signatureTitleText.css({ width: signaturePos.w - titlePaddingWidth - titleBorder });
        } else {
            signatureTitle.hide();
        }

        const mainBoxPos = {
            left: (signaturePos.x - borderSize) + 'px',
            top: (signaturePos.y - borderSize - titleHeight) + 'px',
            width: (signaturePos.w + (2 * borderSize)) + 'px',
            height: (signaturePos.h + titleHeight + (2 * borderSize)) + 'px',
        };
        signatureMainBox.css(mainBoxPos);
        const signSize = { width: signaturePos.w, height: signaturePos.h };
        signatureContainerBox.css(signSize);
        signatureImage.css(signSize);
        signatureWindow.css(signSize);
        signatureWindow.prop('width', signSize.width);
        signatureWindow.prop('height', signSize.height);
        signatureWait.css(signSize);

        self.signatureContainerBox?.focus();

        //if UI is hidden - no need to create modals, user see only pdf page
        if(needModals && !hideui)
            createModals();
    }

    function createModals() {
        const body = $(document.body);
        modal = $('<div class="modal-background"/>').appendTo(body);
        //.modal-background z-index = 1000
        //we need to place pdf image over it, and entire UI under it
        const doccontainer = $('#doccontainer');
        doccontainer.css({
            'position': 'relative',
            'z-index': '1001',
        });
    }

    self.destroy = function() {
        return Promise.resolve()
            .then(() => {
                signatureMainBox.remove();
                signatureSelectionBox.remove();
                if(modal) {
                    modal.remove();
                    const doccontainer = $('#doccontainer');
                    doccontainer.css({
                        'position': '',
                        'z-index': '',
                    });
                }
            })
            .then(() => {
                if(wizardHidden) {
                    return handler.showWizardPane();
                }
                return Promise.resolve();
            })
            .then(() => {
                if(hideui) {
                    return handler.showUi(true);
                }
                return Promise.resolve();
            })
            .then(() => {
                if(zoomRatio) {
                    return handler.revertZoom();
                }
                return Promise.resolve();
            })
            .then(() => {
                handler.freezeUi(false);
            });
    };

    self.position = function(callback) {
        isCurrentlyRendering = true;
        return Promise.resolve()
            .then(() => handler.loadPage(position.page - 1))
            .then(() => {
                if(hideui) {
                    return handler.hideWizardPane()
                        .then((_wizardHidden) => {
                            wizardHidden = _wizardHidden;
                            return handler.showUi(false);
                        });
                }
                return Promise.resolve();
            })
            .then(() => {
            //zoom area is width and height in page units, that should fit screen
                if(zoomRatio) {
                    if(!zoomArea)
                        zoomArea = position;
                    zoomArea = new PdfLocationMillis(zoomArea);
                    return handler.zoomToBox(zoomArea, zoomRatio);
                }
                return Promise.resolve();
            })
            .then(() => {
                const scrollToLocation = new PdfLocationMillis(signarea || position);
                return handler.scrollToLocation(scrollToLocation);
            })
            .then(({ psize, location }) => {
                pointsToScrenRatio = location.pointsToScrenRatio;
                create();
            })
            .then(() => {
                calcPositionAndShow();
            })
            .then(() => {
                handler.freezeUi(true);
            })
            .then(() => {
                callback && callback();
            })
            .finally(() => {
                isCurrentlyRendering = false;
            });
    };

    self.pleaseWait = function(show) {
        signatureWindow.toggle(!show);
        signatureWait.toggle(show);
        if(show) {
            signatureContainerBox.attr('tabindex', '-1');
            self.signatureContainerBox?.blur();
        } else {
            signatureContainerBox.attr('tabindex', '0');
            self.signatureContainerBox?.focus();
        }
    };

    self.setTitle = function(title) {
        signatureTitleText.text(title);
    };
    self.isCurrentlyRendering = function() { return isCurrentlyRendering; };
}

export function useAutoIframeZoom($iframe, _zoom) {
    let rafId = null;
    let zoom = parseZoom(_zoom);
    let lastScale = -1;
    const win = window;

    function parseZoom(_zoom0) {
        const n = parseFloat(_zoom0);
        return (isFinite(n) && n > 0) ? n : 1;
    }

    function normalizeScale(s) {
        if(!isFinite(s) || s <= 0) return 1;
        if(Math.abs(s - 1) < 0.01) return 1;
        return Math.round(s * 1000) / 1000;
    }

    function getNaturalContentSize(doc) {
        const root = doc.documentElement;
        const body = doc.body;
        if(!root || !body) return { width: 1, height: 1 };

        const prevZoom = body.style.zoom;
        const prevTransform = body.style.transform;
        const prevMsTransform = body.style.msTransform;
        const prevWidth = body.style.width;
        const prevHeight = body.style.height;

        body.style.zoom = '';
        body.style.transform = 'none';
        body.style.msTransform = 'none';
        body.style.width = 'auto';
        body.style.height = 'auto';

        const w = Math.max(
            root.scrollWidth || 0,
            root.offsetWidth || 0,
            body.scrollWidth || 0,
            body.offsetWidth || 0,
            1,
        );
        const h = Math.max(
            root.scrollHeight || 0,
            root.offsetHeight || 0,
            body.scrollHeight || 0,
            body.offsetHeight || 0,
            1,
        );

        body.style.zoom = prevZoom;
        body.style.transform = prevTransform;
        body.style.msTransform = prevMsTransform;
        body.style.width = prevWidth;
        body.style.height = prevHeight;

        return { width: w, height: h };
    }

    function applyZoom() {
        const iframe = $iframe[0];
        let cdoc;
        const frameW = $iframe.innerWidth() || iframe.clientWidth || iframe.offsetWidth || 1;
        // const frameH = $iframe.innerHeight() || iframe.clientHeight || iframe.offsetHeight || 1;

        try {
            const cwin = iframe.contentWindow;
            cdoc = iframe.contentDocument || (cwin ? cwin.document : null);
        } catch(e) {
            return;
        }
        if(!cdoc || !cdoc.documentElement || !cdoc.body) return;

        const root = cdoc.documentElement;
        const body = cdoc.body;
        const size = getNaturalContentSize(cdoc);
        let fitScale = frameW / size.width; // width only
        if(!isFinite(fitScale) || fitScale <= 0) fitScale = 1;

        // for scrollbars and centered invoices
        const safety = 0.97;
        let finalScale = normalizeScale(fitScale * zoom * safety);
        finalScale = Math.min(1, finalScale);

        // Prevent endless tiny re-adjustments.
        if(Math.abs(finalScale - lastScale) < 0.0005) return;
        lastScale = finalScale;

        if(finalScale === 1) {
            root.style.overflowX = '';
            root.style.overflowY = '';
            body.style.overflow = '';
            body.style.zoom = '';
            body.style.transform = '';
            body.style.msTransform = '';
            body.style.transformOrigin = '';
            body.style.msTransformOrigin = '';
            //body.style.width = '';
            //body.style.height = '';
        } else {
            root.style.overflowX = 'hidden';
            root.style.overflowY = 'auto';
            body.style.overflow = 'hidden';
            body.style.zoom = finalScale.toFixed(3);
            body.style.transform = '';
            body.style.msTransform = '';
            body.style.transformOrigin = '0 0';
            body.style.msTransformOrigin = '0 0';
            //body.style.width = size.width + 'px';
            //body.style.height = size.height + 'px';
        }
    }

    function scheduleApply() {
        if(rafId && win.cancelAnimationFrame) {
            win.cancelAnimationFrame(rafId);
            rafId = null;
        }
        if(win.requestAnimationFrame) {
            rafId = win.requestAnimationFrame(applyZoom);
        } else {
            setTimeout(applyZoom, 0);
        }
    }

    function setZoom(_zoom0) {
        zoom = parseZoom(_zoom0);
        lastScale = -1; // force reapply after explicit zoom change
        scheduleApply();
    }

    return {
        setZoom,
        scheduleApply,
    };
}

export function useAutoDivZoom($box, $inner, _zoom) {
    let rafId = null;
    let zoom = parseZoom(_zoom);
    let lastScale = -1;
    const win = window;

    $inner.css({
        position: 'absolute',
        left: '0',
        top: '0',
    });
    $box.css({
        position: $box.css('position') === 'static' ? 'relative' : $box.css('position'),
    });

    function parseZoom(_zoom0) {
        const n = parseFloat(_zoom0);
        return (isFinite(n) && n > 0) ? n : 1;
    }

    function normalizeScale(s) {
        if(!isFinite(s) || s <= 0) return 1;
        if(Math.abs(s - 1) < 0.01) return 1;
        return Math.round(s * 1000) / 1000;
    }

    function getNaturalContentSize(el) {
        const prevTransform = el.style.transform;
        const prevMsTransform = el.style.msTransform;
        const prevWidth = el.style.width;
        const prevHeight = el.style.height;

        el.style.transform = 'none';
        el.style.msTransform = 'none';
        el.style.width = 'auto';
        el.style.height = 'auto';

        const w = Math.max(el.scrollWidth || 0, el.offsetWidth || 0, 1);
        const h = Math.max(el.scrollHeight || 0, el.offsetHeight || 0, 1);

        el.style.transform = prevTransform;
        el.style.msTransform = prevMsTransform;
        el.style.width = prevWidth;
        el.style.height = prevHeight;

        return { width: w, height: h };
    }

    function applyZoom() {
        if(!$box[0] || !$inner[0]) return;

        const boxW = $box.innerWidth() || $box[0].clientWidth || $box[0].offsetWidth || 1;
        // const boxH = $box.innerHeight() || $box[0].clientHeight || $box[0].offsetHeight || 1;

        const size = getNaturalContentSize($inner[0]);
        let fitScale = boxW / size.width; // width only
        if(!isFinite(fitScale) || fitScale <= 0) fitScale = 1;

        let finalScale = normalizeScale(fitScale * zoom);
        finalScale = Math.min(1, finalScale);

        // Prevent endless tiny re-adjustments.
        if(Math.abs(finalScale - lastScale) < 0.0005) return;
        lastScale = finalScale;

        if(finalScale === 1) {
            $box.css({
                marginLeft: '',
                marginRight: '',
            });
            $inner.css({
                overflowX: '',
                //overflowY: '',
                //width: '',
                //height: '',
                transform: '',
                msTransform: '',
                transformOrigin: '',
                msTransformOrigin: '',
            });
        } else {
            $box.css({
                marginLeft: '10px',
                marginRight: '10px',
            });
            $inner.css({
                overflowX: 'hidden',
                //overflowY: 'auto',
                //width: size.width + 'px',
                //height: size.height + 'px',
                transform: 'scale(' + finalScale.toFixed(3) + ')',
                msTransform: 'scale(' + finalScale.toFixed(3) + ')',
                transformOrigin: '0 0',
                msTransformOrigin: '0 0',
            });
        }
    }

    function scheduleApply() {
        if(rafId && win.cancelAnimationFrame) {
            win.cancelAnimationFrame(rafId);
            rafId = null;
        }
        if(win.requestAnimationFrame) {
            rafId = win.requestAnimationFrame(applyZoom);
        } else {
            setTimeout(applyZoom, 0);
        }
    }

    function setZoom(_zoom0) {
        zoom = parseZoom(_zoom0);
        scheduleApply();
    }

    return {
        setZoom,
        scheduleApply,
    };
}
